import React, { memo, forwardRef } from "react";
const SvgCapitalMu = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M24.544 23.056c0 .496-.128.84-.384 1.032a1.24 1.24 0 01-.792.288c-.288 0-.56-.096-.816-.288-.256-.192-.384-.536-.384-1.032V11.992h-.048l-4.968 11.304c-.304.72-.776 1.08-1.416 1.08-.64 0-1.12-.36-1.44-1.08L9.376 12.04h-.072v11.04c0 .48-.128.816-.384 1.008-.24.192-.496.288-.768.288-.16 0-.32-.032-.48-.096-.16-.048-.312-.176-.456-.384-.144-.208-.216-.48-.216-.816V8.632c0-.608.16-1.032.48-1.272.32-.24.656-.36 1.008-.36.704 0 1.256.456 1.656 1.368l5.64 12.96h.048l5.616-12.96c.4-.912.944-1.368 1.632-1.368.352 0 .68.12.984.36.32.24.48.664.48 1.272v14.424z"
      />
    </svg>
  );
});
SvgCapitalMu.displayName = "SvgCapitalMu";
const MemoForwardRef = memo(SvgCapitalMu);
export default MemoForwardRef;
